
import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon, CheckCircle as ActivateIcon, Search as SearchIcon, Info as Info } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService'; // Ensure postData is defined
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import ReactDOM from 'react-dom';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select'; // Import react-select

function AttendanceIndex() {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, token, logout, userId } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const branchId = 0;
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [fileData, setFileData] = useState([]);


    useEffect(() => {

        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
    }, [isAuthenticated, companyId, branchId, token, logout]);


    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        // Only reload data if navigated from PurchaseOrderCreate and flag is set
        if (location.state?.from === '/SaleCreate' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/SaleEdit' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }

        else if (location.state?.from === '/SaleDetails' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else {
            // Populate data without reloading for other cases
            setFromDate(getFormattedStartDate());
            setToDate(getFormattedCurrentDate());
            // handleClickOpen(false);
        }
    }, [location]);

    const fetchtableData = async () => {
        let empid = selectedCategoryType.value;
        if (empid != 0) {

            setData([]);
            try {
                const response = await fetchData('AttendanceApi', `/AttendanceDetails/${companyId}/${empid}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Customer Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const searchableFields = ['BillPrefix', 'FinYear', 'BillNumber', 'BillDate', 'CustomerName', 'TotalQuantity', 'TaxableAmount', 'CGSTAmount', 'SGSTAmount', 'IGSTAmount', 'GrandTotal', 'TotalQuantity'];

    const filteredData = data.filter((item) =>
        searchableFields.some((key) =>
            item[key]?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    );



    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const openImportDialog = () => {
        setImportDialogOpen(true);
    };

    const closeImportDialog = () => {
        setImportDialogOpen(false);
        setFileData([]);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const rowsToRead = sheetData.slice(5); // Start from 6th row (index 5)

            const formattedData = rowsToRead
                .filter(row => row[0] && row[3]) // Ensure Employee ID and Date exist
                .map((row) => {
                    const rawDate = row[0];
                    let currentDate = null;
                    let billingDate = "";
                    let dayName = "";

                    if (typeof rawDate === "string" || rawDate instanceof Date) {
                        const parts = rawDate.split("/");
                        if (parts.length === 3) {
                            const [day, month, year] = parts;
                            currentDate = new Date(`${year}-${month}-${day}`);
                        } else {
                            currentDate = new Date(rawDate);
                        }
                    } else if (typeof rawDate === "number") {
                        const parsed = XLSX.SSF.parse_date_code(rawDate);
                        if (parsed) {
                            currentDate = new Date(parsed.y, parsed.m - 1, parsed.d);
                        }
                    }

                    if (currentDate && !isNaN(currentDate)) {
                        const year = currentDate.getFullYear();
                        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                        const day = String(currentDate.getDate()).padStart(2, '0');
                        billingDate = `${year}-${month}-${day}`;
                        dayName = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
                    }

                    return {
                        EmployeeCode: row[2] ? String(row[2]) : "",
                        EmployeeName: row[3] ? String(row[3]) : "",
                        BranchName: row[4] ? String(row[4]) : "",
                        Department: row[5] ? String(row[5]) : "",
                        Designation: row[6] ? String(row[6]) : "",
                        AttendanceDate: billingDate,
                        AttendanceDay: dayName,
                        InTime: row[8] ? parseExcelTime(String(row[8])) : null,
                        LocationIn: row[9] ? String(row[9]) : "",
                        OutTime: row[10] ? parseExcelTime(String(row[10])) : null,
                        LocationOut: row[11] ? String(row[11]) : "",
                        Duration: row[12] && row[12] !== '-' ? formatToTimeSpan(row[12]) : null,
                        Status: row[13] ? String(row[13]) : "",
                        IsActive: true,
                    };
                });

            setFileData(formattedData);
        };

        reader.readAsArrayBuffer(file);
    };


    const formatToTimeSpan = (value) => {
        if (!value || value.trim() === '-' || value.trim() === '') return null;

        const [h, m] = value.trim().split(':').map(Number);
        if (isNaN(h) || isNaN(m)) return null;

        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`; // "hh:mm:ss"
    };


    const BATCH_SIZE = 500; // adjust as needed

    const handleImport = async () => {
        try {
            setIsLoading(true);

            const totalBatches = Math.ceil(fileData.length / BATCH_SIZE);

            for (let i = 0; i < totalBatches; i++) {
                const batch = fileData.slice(i * BATCH_SIZE, (i + 1) * BATCH_SIZE);

                const CreateData = {
                    CompanyId: companyId,
                    CreatedBy: userId,
                    AttendanceImport: batch
                };

                await postData('AttendanceApi', CreateData, token);
                console.log(`Batch ${i + 1} uploaded`);
            }

            setFileData([]);
            closeImportDialog();
            setIsLoading(false);

            setTimeout(() => window.location.reload(), 500);
        } catch (error) {
            console.error('Error posting data:', error);
            setIsLoading(false);
        }
    };


    const cellStyle = {
        padding: '4px 8px',
        border: '1px solid #ccc',
        fontSize: '11px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    };

    const getStatusColor = (status) => {
        if (status === 'P') return 'green';
        if (status === 'MIS') return 'red';
        if (status === 'HLF') return 'orange';
        return 'black';
    };


    function parseExcelTime(timeStr) {
        if (!timeStr || typeof timeStr !== "string") return null;

        const [time, modifier] = timeStr.trim().split(" ");
        if (!time || !modifier) return null;

        let [hours, minutes] = time.split(":").map(Number);

        if (modifier.toUpperCase() === "PM" && hours < 12) {
            hours += 12;
        }
        if (modifier.toUpperCase() === "AM" && hours === 12) {
            hours = 0;
        }

        const hh = String(hours).padStart(2, "0");
        const mm = String(minutes).padStart(2, "0");

        return `${hh}:${mm}:00`;
    }


    // Group by employee name
    const groupedData = data.reduce((acc, item) => {
        if (!acc[item.EmployeeName]) acc[item.EmployeeName] = [];
        acc[item.EmployeeName].push(item);
        return acc;
    }, {});

    const getRowColorByStatus = (statusName) => {
        switch (statusName?.toLowerCase()) {
            case 'p':
                return '#cff8d2ff';
            case 'a':
                return '#fdcbd3ff';
            case 'hlf':
                return '#f7e8baff';
            case 'mis':
                return '#fdcbd3ff';
            default:
                return '#faededff'; // fallback
        }
    };

    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const handleOpenEditModal = (attendanceItem) => {
        setSelectedAttendance(attendanceItem);
        setEditDialogOpen(true);
    };

    const handleCloseEditModal = () => {
        setEditDialogOpen(false);
        setSelectedAttendance(null);
    };


    const [CategoryTypeOptions, setCategoryTypeOptions] = useState([]);
    const [selectedCategoryType, setSelectedCategoryType] = useState("");

    const fetchCategoryType = async () => {
        try {

            const response = await fetchData('EmployeeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(category => ({
                    value: category.Id,
                    label: category.EmployeeCode + '-' + category.EmployeeName
                }));
                setCategoryTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleCategoryTypeChange = (selectedOption) => {
        setSelectedCategoryType(selectedOption);
    };

    useEffect(() => {
        fetchCategoryType();
    }, []);


    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '-10px' }}>

            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Attendance </h6>

                <div className="w-1/3 mr-2">

                    <label className="block uppercase tracking-wide text-black text-xs mb-2" style={{ fontSize: '11px' }}>
                        Employee
                    </label>

                    <Select
                        value={selectedCategoryType}
                        onChange={handleCategoryTypeChange}
                        options={CategoryTypeOptions}
                        placeholder="Employee Name"
                        isSearchable
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '30px',
                                fontSize: '12px',
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                                fontSize: '12px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '30px',
                            }),
                        }}
                    />
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber" style={{ fontSize: '11px' }}>
                        From
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber" style={{ fontSize: '11px' }}>
                        To
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Button
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        padding: '5px 10px',
                        border: '1px solid blue',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '1.50%',
                        textTransform: 'uppercase'
                    }}
                    onClick={fetchtableData}
                    className="linkcolor"
                >
                    <Tooltip title="Get Attendance Details" arrow>
                        Refresh
                    </Tooltip>
                </Button>

                {hasCreateMasterPermission && (
                    <Button

                        onClick={openImportDialog}
                        className="linkcolor"
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '20px',
                            padding: '5px 10px',
                            border: '1px solid black',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            marginTop: '1.50%',
                            textTransform: 'uppercase'

                        }}
                    >
                        <Tooltip title="Create New Attendance" arrow>
                            IMPORT
                        </Tooltip>

                    </Button>
                )}
            </div>

            <div className="w-full mb-4 rounded-xl border border-gray-200 shadow-md overflow-hidden">
                <TableContainer
                    component={Paper}
                    sx={{
                        maxHeight: 580,
                        overflowY: 'auto',
                        border: '1px solid #e0e0e0',
                    }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                {[
                                    'Sl.No', 'Employee ID', 'Employee Name', 'Date', 'Day', 'In Time',
                                    'Out Time', 'Duration', 'Status', 'Location(In)', 'Location(Out)', 'Branch', 'Department',
                                    'Designation'
                                ].map((title, idx) => (
                                    <TableCell
                                        key={idx}
                                        sx={{
                                            background: 'linear-gradient(to right, #103641, #144350)',
                                            color: 'white',
                                            fontWeight: '600',
                                            fontSize: '10px',
                                            border: '1px solid #ccc',
                                            textAlign: idx === 14 ? 'right' : 'center',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 10,
                                            whiteSpace: 'nowrap',
                                            textTransform: 'uppercase',
                                            padding: '0px 2px',
                                        }}
                                    >
                                        {title}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {Object.entries(groupedData).map(([employeeName, records], empIndex) => (
                                <React.Fragment key={employeeName}>
                                    {/* Group Header Row */}
                                    <TableRow sx={{ backgroundColor: '#e0f7fa' }}>
                                        <TableCell colSpan={15} sx={{ fontWeight: 'bold', fontSize: '11.5px', color: '#00695c' }}>
                                            👤  {employeeName}
                                        </TableCell>
                                    </TableRow>

                                    {/* Rows for this employee */}
                                    {records.map((item, index) => (
                                        <TableRow
                                            key={item.id}
                                            sx={{
                                                backgroundColor: getRowColorByStatus(item.statusName),
                                                '&:hover': { backgroundColor: '#d6e4f0' },
                                            }}
                                        >
                                            <TableCell sx={{ ...cellStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Tooltip title="Edit Attendance" arrow>
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleOpenEditModal(item)}
                                                    >
                                                        <EditIcon style={{ fontSize: '13px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                                <span style={{ marginRight: 8 }}>{index + 1}</span>
                                            </TableCell>

                                            <TableCell sx={cellStyle}>{item.EmployeeCode}</TableCell>
                                            <TableCell sx={cellStyle}>{item.EmployeeName}</TableCell>

                                            <TableCell sx={cellStyle}>{formatDate(item.AttendanceDate)}</TableCell>
                                            <TableCell sx={cellStyle}>
                                                {new Date(item.AttendanceDate).toLocaleDateString('en-US', { weekday: 'long' })}
                                            </TableCell>
                                            <TableCell sx={cellStyle}>{item.InTime}</TableCell>
                                            <TableCell sx={cellStyle}>{item.OutTime}</TableCell>
                                            <TableCell sx={cellStyle}>{item.Duration}</TableCell>
                                            <TableCell sx={cellStyle}>{item.statusName}</TableCell>
                                            <TableCell sx={cellStyle}>{item.LocationIn}</TableCell>
                                            <TableCell sx={cellStyle}>{item.LocationOut}</TableCell>
                                            <TableCell sx={cellStyle}>{item.BranchName}</TableCell>
                                            <TableCell sx={cellStyle}>{item.Department}</TableCell>
                                            <TableCell sx={cellStyle}>{item.Designation}</TableCell>

                                        </TableRow>
                                    ))}

                                </React.Fragment>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>

            {/* Import Dialog */}
            <Dialog
                open={importDialogOpen}
                onClose={closeImportDialog}
                aria-labelledby="import-dialog-title"
                aria-describedby="import-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle id="import-dialog-title">Import Attendance</DialogTitle>
                <DialogContent>
                    <DialogContentText id="import-dialog-description">
                        Select an Excel file to import Attendance data. The data will be previewed before importing.
                    </DialogContentText>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        style={{ marginTop: '16px' }}
                    />
                    <TableContainer component={Paper} sx={{ mt: 2, border: '1px solid #ccc' }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {[
                                        "Employee ID", "Employee Name", "Branch", "Department", "Designation", "Date", "Day",
                                        "In Time", "Location(In)", "Out Time", "Location(Out)", "Duration", "Status"
                                    ].map((header, i) => (
                                        <TableCell
                                            key={i}
                                            sx={{
                                                padding: '4px 8px',
                                                border: '1px solid #ccc',
                                                backgroundColor: '#d9e1f2', // light Excel blue
                                                fontWeight: 'bold',
                                                fontSize: '10px',
                                                textAlign: 'center',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fileData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.EmployeeCode}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.EmployeeName}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.BranchName}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.Department}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.Designation}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{formatDate(row.AttendanceDate)}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.AttendanceDay}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.InTime}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.LocationIn}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.OutTime}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.LocationOut}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.Duration}</TableCell>
                                        <TableCell sx={{ ...cellStyle, color: getStatusColor(row.Status) }}>{row.Status}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={closeImportDialog} color="primary">Cancel
                    </Button>

                    <Button variant="contained" onClick={handleImport} color="secondary" disabled={isLoading || fileData.length === 0}>
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Import"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Attendance Dialog */}
            <Dialog
                open={editDialogOpen}
                onClose={handleCloseEditModal}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "16px",
                        boxShadow: "0 6px 30px rgba(0,0,0,0.25)",
                        backgroundColor: "#FAFAFA",
                    },
                }}
                TransitionProps={{
                    onEnter: () => document.body.classList.add("overflow-hidden"),
                    onExited: () => document.body.classList.remove("overflow-hidden"),
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.8px",
                        color: "#2F4858",
                        fontFamily: "Segoe UI, sans-serif",
                        borderBottom: "2px solid #E0E0E0",
                        pb: 1,
                    }}
                >
                    ✏️ Edit Attendance
                </DialogTitle>

                {/* Content */}
                <DialogContent sx={{ mt: 2, px: 3, py: 2 }}>
                    {selectedAttendance && (
                        <div className="space-y-5">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                                {/* In Time */}
                                <div>
                                    <label className="block text-sm text-text mb-1">
                                        In Time
                                    </label>
                                    <input
                                        type="time"
                                        value={selectedAttendance.InTime?.slice(0, 5) || ""}
                                        onChange={(e) =>
                                            setSelectedAttendance({
                                                ...selectedAttendance,
                                                InTime: e.target.value + ":00",
                                            })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-600 focus:border-blue-600 outline-none transition-all duration-150"
                                    />
                                </div>

                                {/* Out Time */}
                                <div>
                                    <label className="block text-sm text-black mb-1">
                                        Out Time
                                    </label>
                                    <input
                                        type="time"
                                        value={selectedAttendance.OutTime?.slice(0, 5) || ""}
                                        onChange={(e) =>
                                            setSelectedAttendance({
                                                ...selectedAttendance,
                                                OutTime: e.target.value + ":00",
                                            })
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-600 focus:border-blue-600 outline-none transition-all duration-150"
                                    />
                                </div>

                                {/* Status */}
                                <div>
                                    <label className="block text-sm text-black mb-1">
                                        Status
                                    </label>
                                    <select
                                        value={
                                            selectedAttendance.statusName === "P"
                                                ? "1"
                                                : selectedAttendance.statusName === "HLF"
                                                    ? "2"
                                                    : selectedAttendance.statusName === "A"
                                                        ? "3"
                                                        : selectedAttendance.statusName === "MIS"
                                                            ? "4"
                                                            : ""
                                        }
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const nameMap = {
                                                "1": "P",
                                                "2": "HLF",
                                                "3": "A",
                                                "4": "MIS",
                                            };
                                            setSelectedAttendance({
                                                ...selectedAttendance,
                                                statusName: nameMap[value],
                                                StatusId: parseInt(value),
                                            });
                                        }}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-blue-600 focus:border-blue-600 outline-none transition-all duration-150"
                                    >
                                        <option value="1">P</option>
                                        <option value="2">HLF</option>
                                        <option value="3">A</option>
                                        <option value="4">MIS</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    )}
                </DialogContent>

                {/* Actions */}
                <DialogActions
                    sx={{
                        borderTop: "1px solid #E0E0E0",
                        mt: 3,
                        py: 2,
                        px: 3,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                    }}
                >
                    <Button
                        onClick={handleCloseEditModal}
                        variant="outlined"
                        sx={{
                            color: "#444",
                            borderColor: "#BDBDBD",
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: "8px",
                            "&:hover": { borderColor: "#1976D2", color: "#1976D2" },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#1976D2",
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: "8px",
                            px: 3,
                            "&:hover": { backgroundColor: "#1257A1" },
                        }}
                        onClick={async () => {
                            try {
                                const statusNameMap = {
                                    1: "P",
                                    2: "HLF",
                                    3: "A",
                                    4: "MIS",
                                };

                                const statusId = selectedAttendance.StatusId;
                                const statusName =
                                    statusNameMap[statusId] || selectedAttendance.statusName;

                                const updatePayload = {
                                    ...selectedAttendance,
                                    StatusId: statusId,
                                    statusName: statusName,
                                    UpdatedBy: userId,
                                    CompanyId: companyId,
                                };

                                console.log("Final Payload", updatePayload);

                                await updateData("AttendanceApi", userId, updatePayload, token);
                                fetchtableData();
                                handleCloseEditModal();
                            } catch (err) {
                                console.error("Update error:", err);
                                alert("Error updating attendance");
                            }
                        }}
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    );
}

export default AttendanceIndex;



